/**
 * Photo upload stack (left column of StudentEdit profile tab).
 * Three full-width drop zones: student / parent / guardian.
 */
import React from "react";
import { CloudArrowUp, User } from "@phosphor-icons/react";

function Slot({ label, testId, accept, onChange }) {
  return (
    <>
      <div className="vs-divider" />
      <div className="eyebrow">{label}</div>
      <label className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-md border-2 border-dashed border-[var(--vs-border-focus)]/40 hover:border-[var(--vs-secondary)] cursor-pointer text-sm transition-colors">
        <CloudArrowUp size={16} weight="duotone" /> Upload {label.toLowerCase()}
        <input data-testid={testId} type="file" accept={accept} className="hidden" onChange={onChange} />
      </label>
    </>
  );
}

export function StudentPhotoStack({ student, onPhotoUpload }) {
  return (
    <div className="lg:col-span-1 vs-card p-5 space-y-4">
      <div className="eyebrow">Student photo</div>
      <div className="aspect-square rounded-md overflow-hidden border border-[var(--vs-border)] bg-[var(--vs-bg-subtle)] grid place-items-center">
        {student.photo_path ? (
          <span className="font-mono text-[11px] text-[var(--vs-text-secondary)] p-3 text-center break-all">{student.photo_path}</span>
        ) : (
          <User size={48} weight="thin" className="text-[var(--vs-text-secondary)]" />
        )}
      </div>
      <label className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-md border-2 border-dashed border-[var(--vs-border-focus)]/40 hover:border-[var(--vs-secondary)] cursor-pointer text-sm transition-colors">
        <CloudArrowUp size={16} weight="duotone" /> Upload student photo
        <input
          data-testid="upload-student-photo"
          type="file"
          accept="image/jpeg,image/png,image/webp"
          className="hidden"
          onChange={(e) => onPhotoUpload("student", e.target.files?.[0])}
        />
      </label>

      <Slot label="Parent photo" testId="upload-parent-photo" accept="image/jpeg,image/png,image/webp" onChange={(e) => onPhotoUpload("parent", e.target.files?.[0])} />
      <p className="text-[11px] text-[var(--vs-text-secondary)]">Stored as a document with type <span className="font-mono">parent_photo</span>.</p>

      <Slot label="Guardian photo" testId="upload-guardian-photo" accept="image/jpeg,image/png,image/webp" onChange={(e) => onPhotoUpload("guardian", e.target.files?.[0])} />
    </div>
  );
}
